import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { SEMANTIC_EVENT_NAME, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_SOURCE, TRIGGER_TYPE } from './globals';
import { trackEvent, trackUserEvent } from '../../analytics';
import type { ZrmClickstreamUserOrUndefined } from '../../analytics/types';

const EVENT_TEMPLATE_ID = '167';

// https://dataportal.zillowgroup.net/event-registry/7240
export const EMPTY_STATE_WITH_FIND_YOUR_RENTAL_BUTTON_EVENT_TYPE_ID = '7240';
export const emitEmptyStateWithFindYourRentalButtonEvent = (user: ZrmClickstreamUserOrUndefined) =>
  trackUserEvent({
    envelope: {
      event_type_id: EMPTY_STATE_WITH_FIND_YOUR_RENTAL_BUTTON_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: TRIGGER_SOURCE.RachelInbox,
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7242
export const SEND_TO_ZRM_INBOX_EVENT_TYPE_ID = '7242';
export const emitSendToZrmInboxEvent = (triggerObjectName: string, user: ZrmClickstreamUserOrUndefined) =>
  trackUserEvent({
    envelope: {
      event_type_id: SEND_TO_ZRM_INBOX_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: 'zrm_inbox_link',
      trigger_object_nm: triggerObjectName,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewMessage,
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7243
export const REDIRECT_TO_RENTALS_SEARCH_PAGE_EVENT_TYPE_ID = '7243';
export const emitRedirectToRentalsSearchPageEvent = () =>
  trackEvent({
    envelope: {
      event_type_id: REDIRECT_TO_RENTALS_SEARCH_PAGE_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: 'find_your_rental_button',
      trigger_object_nm: 'inbox_empty_state',
    },
    semantic: {
      semantic_event_nm: 'continue_search_rentals_empty_state',
      topic_tag_txt: [],
    },
  });

// https://dataportal.zillowgroup.net/event-registry/8617
export const BUYING_PILL_CLICK_EVENT_TYPE_ID = '8617';
export const emitBuyingPillClickEvent = () =>
  trackEvent({
    envelope: {
      event_type_id: BUYING_PILL_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '337',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: 'inbox_tab',
      trigger_source_nm: 'button_to_select_buying_messages',
      trigger_object_nm: 'inbox_tab_message_type_selector',
    },
    semantic: {
      semantic_event_nm: 'messaging_inbox_entry_point',
      topic_tag_txt: [],
    },
  });
